module.exports = __webpack_public_path__ + "static/Portfolio02-cc5d3a5d582c76d8b0ae6a19575b7612.jpg";